"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = __importDefault(require("swiper"));
var modules_1 = require("swiper/modules");
swiper_1.default.use([modules_1.Navigation, modules_1.Pagination, modules_1.EffectFade, modules_1.Autoplay]);
var defaultParameters = {
    speed: 400,
    slidesPerView: 'auto',
    slideActiveClass: '-active',
    effect: 'slide',
    navigation: {
        disabledClass: '-disabled',
    },
};
var Slider = function (sliderOptions) {
    var options = sliderOptions.options, container = sliderOptions.container;
    var paginationEl = null;
    var itemBtnPrev = null;
    var itemBtnNext = null;
    Array.from(container.children).map(function (child) {
        if (child.querySelector('.swiper-pagination')) {
            paginationEl = child.querySelector('.swiper-pagination');
        }
        if (child.classList.contains('-prev')) {
            itemBtnPrev = child;
        }
        if (child.classList.contains('-next')) {
            itemBtnNext = child;
        }
    });
    // eslint-disable-next-line prefer-object-spread
    var navigation = Object.assign({}, __assign({}, defaultParameters.navigation), {
        prevEl: itemBtnPrev || undefined,
        nextEl: itemBtnNext || undefined,
    }, options === null || options === void 0 ? void 0 : options.navigation);
    // eslint-disable-next-line prefer-object-spread
    var pagination = Object.assign({}, {
        // eslint-disable-next-line id-length
        el: paginationEl || undefined,
        clickable: true,
        type: 'bullets',
    }, options === null || options === void 0 ? void 0 : options.pagination);
    // eslint-disable-next-line prefer-object-spread
    var parameters = Object.assign(__assign({}, defaultParameters), options, {
        pagination: pagination,
        navigation: navigation,
    });
    return new swiper_1.default(container, parameters);
};
exports.default = Slider;
